// extracted by mini-css-extract-plugin
export default {"xs":"0","s":"576px","m":"768px","l":"1024px","xl":"1200px"};